import gql from 'graphql-tag'
import { dayOrder } from '../fragments'

const updateDateOrderMutation = gql`
mutation CA_Mutation_updateDateOrderValues($id: ID!, $fields: DateOrderValuesInput) {
	cashAssist {
		updateDateOrderValues(id: $id, fields: $fields) {
			...dayOrder
		}
	}
}
${dayOrder}`

export default updateDateOrderMutation
